<template>
  <div class="wrapper">
    <div class="code-apply">
      <div class="code-apply-amount">
        <h2 class="amount">{{ productCount | formatCount }}</h2>
        <p class="desc">物料数量</p>
      </div>
      <div class="code-apply-amount">
        <h2 class="amount">{{ productBrandCount | formatCount }}</h2>
        <p class="desc">品牌数量</p>
      </div>
      <div class="code-apply-amount">
        <h2 class="amount">{{ repertoryCount | formatCount }}</h2>
        <p class="desc">总库存数量</p>
      </div>
      <div class="code-apply-amount">
        <h2 class="amount">{{ traceCodeCount | formatCount }}</h2>
        <p class="desc">已用码数量</p>
      </div>
    </div>
  </div>
</template>

<script>
import "../../assets/icons/iconfont.css";
import { getIndexStatistics, getUserNavList } from "@/common/api.js";
import { TabView } from "../../components/TabView";
import { mapState } from "vuex";
import screenfull from "screenfull";

export default {
  components: {},
  props: {},
  data() {
    return {
      productCount: 0,
      productBrandCount: 0,
      repertoryCount: 0,
      traceCodeCount: 0,
    };
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {
    this.getCounts();
  },
  methods: {
    getCounts() {
      getIndexStatistics().then((res) => {
        this.loading = false;
        if (res.errorCode == 200) {
          this.productCount = res.productCount;
          this.productBrandCount = res.productBrandCount;
          this.repertoryCount = res.repertoryCount;
          this.traceCodeCount = res.traceCodeCount;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
  filters: {
    formatCount(num) {
      var newStr = "";
      var count = 0;
      var str = String(num);
      // 当数字是整数
      if (str.indexOf(".") == -1) {
        for (var i = str.length - 1; i >= 0; i--) {
          if (count % 3 == 0 && count != 0) {
            newStr = str.charAt(i) + "," + newStr;
          } else {
            newStr = str.charAt(i) + newStr;
          }
          count++;
        }
        // str = newStr + ".00"; //自动补小数点后两位
        return newStr;
      } else {
        return num;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.wrapper {
  width: 100%;
  height: 100%;
  /deep/.el-table__header .has-gutter th {
    background-color: #f5f5f6 !important;
    color: #676a6c;
    border-bottom: 1px solid #ccc;
  }
  /deep/.el-table__header .has-gutter th {
    background-color: #f5f5f6 !important;
    color: #676a6c;
    border-bottom: 1px solid #ccc;
  }
  /deep/.el-table__fixed-right .el-table__fixed-header-wrapper th {
    background-color: #f5f5f6 !important;
    color: #676a6c;
    border-bottom: 1px solid #ccc;
  }

  .code-apply {
    height: 250px;
    width: 90%;
    margin-left: 5%;
    display: flex;
    // justify-content: space-between;
    .code-apply-amount {
      width: 30%;
      text-align: center;
      margin-top: 50px;
      margin-right: 3%;
      background-color: #ffffff;
      border-radius: 10px;
      box-shadow: 0 0 10px #b7d4e2;
      .amount {
        font-size: 24px;
        margin-top: 60px;
        word-break: break-all;
        word-wrap: break-word;
        white-space: pre-wrap;
      }
      .desc {
        margin-top: 30px;
        font-size: 18px;
      }
    }
  }
  .code-amount-box {
    display: inline-block;
    .box-title {
      margin-top: 50px;
      text-align: center;
    }
  }
  .el-main {
    overflow: hidden;
  }
  .indexcontainer {
    width: 100%;
    height: 100%;
    .el-header {
      position: fixed;
      z-index: 9;
      width: 100%;
      background-color: #4e97d9;
      height: 60px !important;
      padding: 0 !important;
      // line-height: 88px;
      img.admin-logo {
        width: 220px;
        height: 40px;
        margin-top: 10px;
        margin-left: 30px;
      }
      .headBox {
        height: 60px;
        width: 100%;
        line-height: 60px;
        .btn-fullscreen {
          float: right;
          .iconfont {
            margin-right: 10px;
            cursor: pointer;
          }
        }
        .right-menu {
          float: right;
          height: 100%;
          line-height: 60px;
        }
        .avatar-container {
          margin-right: 30px;
          .avatar-wrapper {
            position: relative;
            .user-avatar {
              cursor: pointer;
              width: 40px;
              height: 40px;
              margin-top: 10px;
              border-radius: 50%;
              vertical-align: top;
            }
            .user-name {
              float: right;
              margin-left: 10px;
              color: #ffffff;
              font-size: 14px;
              font-weight: 600;
            }
            .el-icon-caret-bottom {
              cursor: pointer;
              position: absolute;
              right: -20px;
              top: 35px;
              font-size: 16px;
            }
          }
        }
      }
    }
    .el-main {
      margin-left: 200px;
      margin-top: 60px;
      padding-top: 0;
      height: calc(100% - 60px);
    }
    .main_conainer {
      margin-left: 64px;
    }
    .el-aside {
      position: fixed;
      z-index: 9;
      height: calc(100% - 60px);
      margin-top: 60px;
      background-color: #333744;
      .toggle-button {
        background-color: #4a5064;
        font-size: 10px;
        line-height: 24px;
        color: #fff;
        text-align: center;
        letter-spacing: 0.2em;
        cursor: pointer;
      }
      .el-menu {
        border-right: none;
      }
      .navtages {
        height: 56px;
        max-width: 160px;
        line-height: 56px;
        color: #ffffff;
        padding: 0 20px;
        cursor: pointer;
        i {
          font-size: 18px;
          margin-right: 10px;
          color: #a7b1c2;
        }
        span {
          font-size: 14px;
        }
      }
    }
    .banner {
      width: 100%;
      text-align: center;
      img {
        width: 80%;
        margin-top: 10px;
      }
    }
    .iconfont {
      margin-right: 10px;
      font-size: 16px;
      color: #a7b1c2;
    }
    .screenicon {
      font-size: 24px;
      color: #fff;
    }
    .el-menu-item {
      color: #a7b1c2 !important;
    }
    .el-menu-item.is-active {
      color: #ffffff !important;
      background-color: #1890ff !important;
    }
    .el-submenu .el-menu-item {
      height: 36px !important;
      line-height: 36px !important;
    }
  }
  /deep/.cell .el-button--mini {
    padding: 2px 3px;
    margin-left: 5px;
  }
  /deep/.el-dialog__header {
    padding-top: 10px;
    background: #f8f8f8;
    border-bottom: 1px solid #ddd;
    .el-dialog__title {
      font-size: 16px;
    }
    .el-dialog__headerbtn {
      top: 10px;
    }
  }
  /deep/.el-dialog__footer {
    padding-bottom: 10px;
    background: #f8f8f8;
    border-top: 1px solid #ddd;
    .el-button {
      padding: 10px 15px;
    }
  }

  /* button color */
  /deep/.el-button--cyan.is-active,
  .el-button--cyan:active {
    background: #20b2aa;
    border-color: #20b2aa;
    color: #ffffff;
  }

  /deep/.el-button--cyan:focus,
  /deep/.el-button--cyan:hover {
    background: #48d1cc;
    border-color: #48d1cc;
    color: #ffffff;
  }

  /deep/.el-button--cyan {
    background-color: #20b2aa;
    border-color: #20b2aa;
    color: #ffffff;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/system/homeIndex.vue